import { getWindow } from "../getWindow"

const ssrWindow = getWindow()

/**
 * Checks if the current platform is an iPad, iPhone, or iPod.
 * @returns {boolean} - Returns true if the current platform is an iPad, iPhone, or iPod.
 */
export default () =>
  !!ssrWindow.navigator.platform &&
  /iPad|iPhone|iPod/.test(ssrWindow.navigator.platform)
